/**
 * Grobe Browser-/OS-Erkennung aus dem User-Agent-String, fürs Melde-Werkzeug
 * (bug-report). Keine Fremdbibliothek nötig — die Einstufung muss nur
 * "brauchbar für die Triage" sein, nicht hundertprozentig exakt.
 */
export interface BrowserInfo {
  name: string;
  version: string;
  os: string;
  userAgent: string;
  /** Grobe Einstufung: bekannter Evergreen-Browser in aktueller Major-Version? */
  supported: boolean;
}

/** Mindest-Major-Version je Browser, ab der er als "unterstützt" gilt. */
const MIN_SUPPORTED_VERSION: Record<string, number> = {
  Chrome: 100,
  Edge: 100,
  Firefox: 100,
  Safari: 15,
  Opera: 85,
};

function detectOs(ua: string): string {
  if (/Windows/i.test(ua)) return 'Windows';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
  if (/Mac OS X/i.test(ua)) return 'macOS';
  if (/Android/i.test(ua)) return 'Android';
  if (/Linux/i.test(ua)) return 'Linux';
  return 'Unbekannt';
}

/** Reihenfolge wichtig: Edge/Opera enthalten "Chrome" im UA-String, Chrome enthält "Safari". */
function detectNameAndVersion(ua: string): { name: string; version: string } {
  let m = ua.match(/Edg\/([\d.]+)/);
  if (m) return { name: 'Edge', version: m[1] };
  m = ua.match(/OPR\/([\d.]+)/);
  if (m) return { name: 'Opera', version: m[1] };
  m = ua.match(/Chrome\/([\d.]+)/);
  if (m) return { name: 'Chrome', version: m[1] };
  m = ua.match(/Firefox\/([\d.]+)/);
  if (m) return { name: 'Firefox', version: m[1] };
  m = ua.match(/Version\/([\d.]+).*Safari/);
  if (m) return { name: 'Safari', version: m[1] };
  return { name: 'Unbekannt', version: '0' };
}

export function getBrowserInfo(): BrowserInfo {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const { name, version } = detectNameAndVersion(ua);
  const os = detectOs(ua);
  const majorVersion = parseInt(version.split('.')[0] ?? '0', 10);
  const minVersion = MIN_SUPPORTED_VERSION[name];
  const supported = minVersion !== undefined && Number.isFinite(majorVersion) && majorVersion >= minVersion;
  return { name, version, os, userAgent: ua, supported };
}
